import { render, staticRenderFns } from "./processProducts.vue?vue&type=template&id=0f1ef50c&scoped=true&"
import script from "./processProducts.vue?vue&type=script&lang=js&"
export * from "./processProducts.vue?vue&type=script&lang=js&"
import style0 from "./processProducts.vue?vue&type=style&index=0&id=0f1ef50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ef50c",
  null
  
)

export default component.exports